
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomNavigation } from '../../components/feature/BottomNavigation';
import { Button } from '../../components/base/Button';

const nearbyLaundries = [
  {
    id: 1,
    name: 'مغسلة النظافة الذهبية',
    rating: 4.8,
    deliveryTime: '45-60 دقيقة',
    startingPrice: 15,
    image: 'https://public.readdy.ai/ai/img_res/3e0838fe0273452c15b4e65a3d49471c.jpg',
    services: ['غسيل عادي', 'كي', 'تنظيف جاف'],
    offers: 'خصم 20% على الطلب الأول'
  },
  {
    id: 2,
    name: 'مغسلة الأناقة الحديثة',
    rating: 4.6,
    deliveryTime: '30-45 دقيقة',
    startingPrice: 12,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20laundry%20service%20building%2C%20contemporary%20design%2C%20clean%20white%20facade%2C%20professional%20appearance%2C%20realistic%20photography%20style%2C%20high%20quality%20details&width=300&height=200&seq=2&orientation=landscape',
    services: ['غسيل عادي', 'ملابس نسائية', 'مفارش'],
    offers: null
  },
  {
    id: 3,
    name: 'مغسلة السرعة والجودة',
    rating: 4.9,
    deliveryTime: '20-35 دقيقة',
    startingPrice: 18,
    image: 'https://readdy.ai/api/search-image?query=Fast%20quality%20laundry%20service%20storefront%2C%20modern%20commercial%20building%2C%20speed%20and%20quality%20themed%20design%2C%20professional%20appearance%2C%20realistic%20photography%20style&width=300&height=200&seq=3&orientation=landscape',
    services: ['غسيل سريع', 'كي', 'تنظيف جاف', 'ملابس رياضية'],
    offers: 'توصيل مجاني للطلبات فوق 50 ريال'
  }
];

export default function HomePage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('الكل');

  const filters = ['الكل', 'الأقرب', 'الأسرع', 'الأرخص', 'الأعلى تقييماً'];

  const handleLaundrySelect = (laundryId: number) => {
    navigate(`/laundry/${laundryId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header */}
      <div className="bg-white shadow-sm fixed top-0 left-0 right-0 z-40">
        <div className="px-4 pt-4 pb-3">
          {/* User Info and Notifications */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                <i className="ri-user-line text-white text-lg" />
              </div>
              <div>
                <p className="text-sm text-gray-500">مرحباً</p>
                <p className="font-semibold text-gray-900 text-base">أحمد محمد</p>
              </div>
            </div>
            <button className="w-12 h-12 flex items-center justify-center bg-gray-50 rounded-full">
              <i className="ri-notification-line text-gray-600 text-xl" />
            </button>
          </div>

          {/* Location */}
          <div className="flex items-center gap-2 mb-4 bg-gray-50 rounded-lg p-3">
            <i className="ri-map-pin-line text-blue-500 text-lg" />
            <div className="flex-1">
              <span className="text-sm text-gray-600">الموقع الحالي:</span>
              <p className="text-sm font-medium text-gray-900">الرياض، حي النخيل</p>
            </div>
            <button className="text-blue-500 text-sm font-medium">تغيير</button>
          </div>

          {/* Search */}
          <div className="relative">
            <input
              type="text"
              placeholder="ابحث عن مغسلة قريبة..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-12 pr-4 py-3 bg-gray-100 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-none"
            />
            <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-48 px-4">
        {/* Map Section */}
        <div className="bg-white rounded-xl shadow-sm mb-6 overflow-hidden">
          <div className="h-48 bg-gray-200 relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.1!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzQ5LjAiTiA0NsKwNDAnMzEuMSJF!5e0!3m2!1sen!2ssa!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <div className="absolute top-4 right-4">
              <button className="w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center">
                <i className="ri-focus-3-line text-blue-500" />
              </button>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="mb-6">
          <div className="flex gap-3 overflow-x-auto pb-2">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setSelectedFilter(filter)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                  selectedFilter === filter
                    ? 'bg-blue-500 text-white'
                    : 'bg-white text-gray-600 border border-gray-200'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        {/* Quick Services */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">خدمات سريعة</h3>
          <div className="grid grid-cols-4 gap-4">
            {[
              { icon: 'ri-shirt-line', label: 'غسيل عادي', color: 'bg-blue-100 text-blue-600' },
              { icon: 'ri-iron-line', label: 'كي فقط', color: 'bg-green-100 text-green-600' },
              { icon: 'ri-drop-line', label: 'تنظيف جاف', color: 'bg-purple-100 text-purple-600' },
              { icon: 'ri-home-line', label: 'مفارش', color: 'bg-orange-100 text-orange-600' }
            ].map((service, index) => (
              <div key={index} className="text-center">
                <div className={`w-16 h-16 rounded-full ${service.color} flex items-center justify-center mx-auto mb-2`}>
                  <i className={`${service.icon} text-2xl`} />
                </div>
                <p className="text-xs text-gray-600">{service.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Nearby Laundries */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">المغاسل القريبة</h3>
            <button className="text-blue-500 text-sm">عرض الكل</button>
          </div>

          <div className="space-y-4">
            {nearbyLaundries.map((laundry) => (
              <div
                key={laundry.id}
                className="bg-white rounded-lg shadow-sm overflow-hidden"
                onClick={() => handleLaundrySelect(laundry.id)}
              >
                <div className="flex">
                  <img
                    src={laundry.image}
                    alt={laundry.name}
                    className="w-24 h-24 object-cover"
                  />
                  <div className="flex-1 p-4">
                    <div className="flex items-start justify-between mb-2">
                      <h4 className="font-semibold text-gray-900 text-sm">{laundry.name}</h4>
                      {laundry.offers && (
                        <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded">
                          عرض
                        </span>
                      )}
                    </div>
                    
                    <div className="flex items-center gap-4 mb-2">
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-yellow-400 text-sm" />
                        <span className="text-sm text-gray-600">{laundry.rating}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <i className="ri-time-line text-gray-400 text-sm" />
                        <span className="text-sm text-gray-600">{laundry.deliveryTime}</span>
                      </div>
                    </div>
                    
                    <div className="flex items-center justify-between">
                      <div className="flex flex-wrap gap-1">
                        {laundry.services.slice(0, 2).map((service, index) => (
                          <span key={index} className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded">
                            {service}
                          </span>
                        ))}
                        {laundry.services.length > 2 && (
                          <span className="text-gray-400 text-xs">+{laundry.services.length - 2}</span>
                        )}
                      </div>
                      <span className="text-sm font-semibold text-gray-900">
                        من {laundry.startingPrice} ريال
                      </span>
                    </div>
                    
                    {laundry.offers && (
                      <p className="text-xs text-blue-600 mt-2">{laundry.offers}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Emergency Service */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-lg p-4 text-white mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="font-semibold mb-1">خدمة طوارئ</h4>
              <p className="text-sm opacity-90">توصيل خلال ساعتين</p>
            </div>
            <Button 
              variant="secondary" 
              size="sm"
              onClick={() => navigate('/emergency-order')}
            >
              اطلب الآن
            </Button>
          </div>
        </div>

      </div>

      <BottomNavigation />
    </div>
  );
}
